var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 16.1673C13.0249 16.1673 14.6666 14.5257 14.6666 12.5007C14.6666 10.4756 13.0249 8.83398 10.9999 8.83398C8.97487 8.83398 7.33325 10.4756 7.33325 12.5007C7.33325 14.5257 8.97487 16.1673 10.9999 16.1673Z",
    stroke: "white",
    strokeWidth: 1.46667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 16.1667V8.83333C2.75 6.30203 4.80203 4.25 7.33333 4.25H14.6667C17.198 4.25 19.25 6.30203 19.25 8.83333V16.1667C19.25 18.698 17.198 20.75 14.6667 20.75H7.33333C4.80203 20.75 2.75 18.698 2.75 16.1667Z",
    stroke: "white",
    strokeWidth: 1.46667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 7.46814L16.0517 7.45703",
    stroke: "white",
    strokeWidth: 1.46667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg1);
export default __webpack_public_path__ + "static/media/ig-1.50cf2b57b33070a056ef0b5bda361dfa.svg";
export { ForwardRef as ReactComponent };